import { requestApi } from "./axiosHelper"

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1"

const blogEP = rootUrl + "/blog"

const blogApi = {
  fetchAllBlogs: async () => {
    try {
      const axiosData = {
        url: blogEP,
        method: "get",
      }
      const data = await requestApi(axiosData, true)

      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  getABlog: async (slug) => {
    try {
      const axiosData = {
        url: `${blogEP}/${slug}`,
        method: "get",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  createABlog: async ({
    title,
    image,
    content,
    authorName,
    authorLink,
    editorLink,
    authorId,
    editedBy,
  }) => {
    try {
      const axiosData = {
        url: `${blogEP}/create`,
        method: "post",
        data: {
          title,
          image,
          content,
          authorName,
          authorLink,
          editorLink,
          authorId,
          editedBy,
        },
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  editABlog: async (slug, update) => {
    try {
      const axiosData = {
        url: `${blogEP}/edit/${slug}`,
        method: "patch",
        data: (slug, update),
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  deleteABlog: async (_id) => {
    try {
      const axiosData = {
        url: `${blogEP}/${_id}`,
        method: "delete",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
}

export default blogApi
